import { Box, CircularProgress, Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useEffect, useState } from 'react';
import { getJobsFromAdvancedQuery, IJob, IJobSearchFilterDTO } from 'wisestep-api';
import {
  Item,
  WsColors,
  WsDrawer,
  WsJobSelect,
  WsTypoColors,
  WsTypoVariants,
  WsTypography,
} from 'wisestep-base';

export interface IComponentProps {
  setOpenJobPopup: (isOpen: boolean) => void;
  setSelectedJob: (job: IJob) => void;
  jobSearchDTO: IJobSearchFilterDTO;
}

const ClosureJobPopup = ({ setOpenJobPopup, setSelectedJob, jobSearchDTO }: IComponentProps) => {
  const [jobList, setJobList] = useState<IJob[]>([]);
  const [showNoJobs, setShowNoJobs] = useState<boolean>(false);
  const [showLoader, setShowLoader] = useState<boolean>(true);

  useEffect(() => {
    const getJobsForClient = async () => {
      try {
        const response = await getJobsFromAdvancedQuery(jobSearchDTO);
        if (isEmpty(response.data)) {
          setShowNoJobs(true);
        } else {
          setShowNoJobs(false);
          setJobList(response.data);
        }
        setShowLoader(false);
      } catch (err) {
        console.error('Error while fetching jobs : %o', err);
        setShowNoJobs(true);
        setShowLoader(false);
      }
    };
    getJobsForClient();
  }, [jobSearchDTO]);

  const getSelectedJob = async (job: IJob) => {
    setSelectedJob(job);
    setOpenJobPopup(false);
  };

  return (
    <>
      <WsDrawer
        title="Select Job"
        open={true}
        onClose={() => setOpenJobPopup(false)}
        size="medium"
        headerSize="small"
      >
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid container item px={2.5} pt={2} component="form">
            <Grid container direction="row">
              <Grid item xs={12}>
                {showLoader ? (
                  <Box textAlign="center" pt="30%">
                    <CircularProgress disableShrink sx={{ color: WsColors.TheBlues500 }} />
                  </Box>
                ) : (
                  <Item>
                    {jobList.map((job: IJob, index: number) => (
                      <WsJobSelect key={index} job={job} getSelectedJob={getSelectedJob} />
                    ))}
                  </Item>
                )}
                {showNoJobs && (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'center',
                      gap: 3,
                      mx: '1%',
                      py: '10%',
                    }}
                  >
                    <Box textAlign="center">
                      <WsTypography
                        variant={WsTypoVariants.TITLE}
                        color={WsTypoColors.SECONDARY}
                        bold
                      >
                        No Jobs have been posted for the selected client. Please add the Job
                        Details.
                      </WsTypography>
                    </Box>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </WsDrawer>
    </>
  );
};

export default ClosureJobPopup;
